<template>
  <div class="login">
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" :bordered="false">
        <div class="form-con">
          <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="login">
            <FormItem prop="username">
              <Input v-model="form.username" placeholder="请输入用户名">
                <span slot="prepend">
                  <Icon :size="16" type="ios-person"></Icon>
                </span>
              </Input>
            </FormItem>
            <FormItem prop="password">
              <Input type="password" v-model="form.password" placeholder="请输入密码">
                <span slot="prepend">
                  <Icon :size="14" type="md-lock"></Icon>
                </span>
              </Input>
            </FormItem>
            <FormItem>
              <Button @click="login" type="primary" long>登录</Button>
            </FormItem>
          </Form>
        </div>
      </Card>
    </div>
  </div>

</template>

<script>
import conf from "./im/conf";
import RequestUtils from "../utils/RequestUtils";
import StoreUtils from "../utils/StoreUtils";
import { ErrorType } from "../utils/ChatUtils";

export default {
  name: "login",
  data() {
    return {
      app_name: conf.app_name,      
      form: {
        username: '',
        password: ''  
      },
      err: "",
      showErr: false,
      showSetting: false,
      showRegister: false,
      host: "101.200.151.183",
      device: 'pc'
    };
  },
  props: {
    userNameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ]
      }
    },
    passwordRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    rules () {
      return {
        username: this.userNameRules,
        password: this.passwordRules
      }
    }
  },
  methods: {
    login: function() {
      let self = this;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          RequestUtils.login(self.form.username.trim(), self.form.password.trim(), self)
          .then(data => {
            return new Promise(resolve => {
              resolve(data);
            });
          })
          .then(data => {
            StoreUtils.setToken(data.token);
            //个人信息
            self.$store.commit("setUser", data.user);
            // 跳转到index 页面
            self.$router.push({
              path: "/chat/main",
              params: {}
            });
          })
          .catch(function(error) {
            let errorMsg = '';
            if (ErrorType.NET_ERROR === error.toString()) {
              errorMsg = "服务通讯失败，请检查服务设置";
            } else {
              errorMsg = error.toString();
            }
            self.$Message.error(errorMsg);
          });
        }

      })
      
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/static/styles/theme.scss";

.login{
    width: 100%;
    height: 100%;
    background-image: url('~@/static/img/login-bg.jpg');
    background-size: cover;
    background-position: center;
    position: relative;
    &-con{
        position: absolute;
        right: 160px;
        top: 50%;
        transform: translateY(-60%);
        width: 300px;
        &-header{
            font-size: 16px;
            font-weight: 300;
            text-align: center;
            padding: 30px 0;
        }
        .form-con{
            padding: 10px 0 0;
        }
        .login-tip{
            font-size: 10px;
            text-align: center;
            color: #c3c3c3;
        }
    }
}

</style>
